var map = {
	"./bell.svg": "2fa4",
	"./category.svg": "f428",
	"./cleans.svg": "bdcc",
	"./customer-settlements.svg": "bde1",
	"./customers.svg": "7602",
	"./dashboard.svg": "f782",
	"./deliver-settlements.svg": "0f28",
	"./download.svg": "4dae",
	"./factory-settlements.svg": "a377",
	"./flag.svg": "be7f",
	"./history.svg": "c023",
	"./link.svg": "18f0",
	"./lms.svg": "e95c",
	"./lms1.svg": "f5c7",
	"./lms2.svg": "2868",
	"./material-settlements.svg": "2528",
	"./medal.svg": "428d",
	"./menu.svg": "bd3d",
	"./mes.svg": "1f48",
	"./mes1.svg": "438b",
	"./message.svg": "47ff",
	"./mms.svg": "7768",
	"./mms1.svg": "c49b",
	"./oms.svg": "8fb5",
	"./payMethod.svg": "2680",
	"./pms.svg": "6e71",
	"./product.svg": "8d30",
	"./prohibit.svg": "208d",
	"./rent.svg": "f12b",
	"./rents.svg": "cc86",
	"./report.svg": "9e5c",
	"./salaries.svg": "021d",
	"./sale-settlements.svg": "e50d",
	"./schedules.svg": "a013",
	"./serial.svg": "61a7",
	"./serialNo.svg": "5763",
	"./set.svg": "9873",
	"./shop.svg": "5def",
	"./shortcut.svg": "f31d",
	"./spot.svg": "3b94",
	"./supplier-settlements.svg": "6ceb",
	"./suppliers.svg": "a36d",
	"./user.svg": "b3b5",
	"./users.svg": "5055",
	"./verify.svg": "f9f0",
	"./wms.svg": "aa15",
	"./wms1.svg": "7d98",
	"./wms2.svg": "e8f3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";